/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { prefixSearchStrategy } from 'src/core/utils/searchStrategies/prefixSearchStrategy';
import { substringSearchStrategy } from 'src/core/utils/searchStrategies/substringSearchStrategy';

export const SearchStrategy = { prefixSearchStrategy, substringSearchStrategy };
